module.exports = __webpack_public_path__ + "static/media/sport_area.c2a5d603.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/features/sport_area.svg
// module id = 1448
// module chunks = 0